module.exports = __webpack_public_path__ + "static/media/southafrican.ec61add1.png";